module.exports = __webpack_public_path__ + "media/images/users/travel-490a32110521be65cd7a29c4b49ac2ef.png";